module.exports = __webpack_public_path__ + "59ee70efb15754d423aec9ec28843f8b.glb";